import React from 'react';
import { Box, keyframes } from '@mui/material';
import JSIImage from '../layout/JSI.png';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const rotateReverse = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
`;

const AnimatedJSILogo: React.FC<{ size?: number }> = ({ size = 300 }) => {
  return (
    <Box
      sx={{
        width: `${size}px`,
        height: `${size}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      {/* Outer circle */}
      <Box
        sx={{
          position: 'absolute',
          width: `${size * 1.3}px`,
          height: `${size * 1.3}px`,
          borderRadius: '50%',
          background: 'conic-gradient(from 0deg, transparent 0deg, transparent 210deg, #1BA973 225deg, #0897AB 255deg, #5C50F3 285deg, #1BA973 360deg)',
          animation: `${rotate} 6s linear infinite`,
          WebkitMask: 'radial-gradient(circle, transparent 0%, transparent calc(50% - 5px), black calc(50% - 5px), black calc(50% - 1px), transparent calc(50% - 1px))',
          mask: 'radial-gradient(circle, transparent 0%, transparent calc(50% - 5px), black calc(50% - 5px), black calc(50% - 1px), transparent calc(50% - 1px))',
          '&::before': {
            content: '""',
            position: 'absolute',
            width: '4px',
            height: '4px',
            borderRadius: '50%',
            background: '#1BA973',
            top: 'calc(50% - 3px)',
            left: '0',
            zIndex: 2,
          },
        }}
      />
      
      {/* Middle circle */}
      <Box
        sx={{
          position: 'absolute',
          width: `${size * 1.05}px`,
          height: `${size * 1.05}px`,
          borderRadius: '50%',
          background: 'conic-gradient(from 180deg, #0897AB 0deg, #1BA973 45deg, #0897AB 90deg, #5C50F3 135deg, transparent 150deg, transparent 360deg)',
          animation: `${rotateReverse} 8s linear infinite`,
          WebkitMask: 'radial-gradient(circle, transparent 0%, transparent calc(50% - 4px), black calc(50% - 4px), black calc(50% - 1px), transparent calc(50% - 1px))',
          mask: 'radial-gradient(circle, transparent 0%, transparent calc(50% - 4px), black calc(50% - 4px), black calc(50% - 1px), transparent calc(50% - 1px))',
          '&::before': {
            content: '""',
            position: 'absolute',
            width: '3px',
            height: '3px',
            borderRadius: '50%',
            background: '#5C50F3',
            top: 'calc(50% - 2.5px)',
            right: '0',
            zIndex: 2,
          },
        }}
      />
      
      {/* Inner circle */}
      <Box
        sx={{
          position: 'absolute',
          width: `${size * 0.8}px`,
          height: `${size * 0.8}px`,
          borderRadius: '50%',
          background: 'conic-gradient(from 0deg, transparent 0deg, transparent 200deg, #0897AB 215deg, #1BA973 245deg, #5C50F3 275deg, #0897AB 360deg)',
          animation: `${rotate} 4s linear infinite`,
          WebkitMask: 'radial-gradient(circle, transparent 0%, transparent calc(50% - 3px), black calc(50% - 3px), black calc(50% - 1px), transparent calc(50% - 1px))',
          mask: 'radial-gradient(circle, transparent 0%, transparent calc(50% - 3px), black calc(50% - 3px), black calc(50% - 1px), transparent calc(50% - 1px))',
          '&::before': {
            content: '""',
            position: 'absolute',
            width: '2px',
            height: '2px',
            borderRadius: '50%',
            background: '#0897AB',
            top: 'calc(50% - 2px)',
            left: '0',
            zIndex: 2,
          },
        }}
      />
      
      {/* JSI Logo */}
      <Box
        component="img"
        src={JSIImage}
        alt="JSI Logo"
        sx={{
          width: `${size * 0.4}px`,
          height: 'auto',
          zIndex: 1,
        }}
      />
    </Box>
  );
};

export default AnimatedJSILogo;